import { Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import PurchaseProduct from "../../actions/purchaseProduct";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";

const initialFValues = {
  name: "",
  quantity: "",
  editing: false,
};

const UpdatePurchaseContainer = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getPurchasesByContainer,
}) => {
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  const { updateContainer } = PurchaseProduct();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("name" in fieldValues)
      temp.name =
        fieldValues.name.length !== 0 ? "" : "This field is required.";

    if ("quantity" in fieldValues)
      temp.quantity =
        fieldValues.quantity.length !== 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });
      delete values.logginError;
      delete values.editing;
      updateContainer(values, values.id).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else {
          NotifyMessage({
            message: "Purchase Container successfully updated",
            type: "success",
          });
          setOpenPopup(false);
          resetForm();
          if (typeof getPurchasesByContainer === "function") {
            getPurchasesByContainer();
          }
        }
      });
    }
  };

  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="name"
            label="Name"
            value={values.name}
            onChange={handleInputChange}
            error={errors.name}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="quantity"
            label="Quantity"
            value={values.quantity}
            onChange={handleInputChange}
            error={errors.quantity}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={values.submitting ? "Editing..." : "Done"}
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default UpdatePurchaseContainer;
